import { uploadPdf } from "@/features/invoice-overview/utils/uploadUtils";
import { InvoiceType } from "@/lib/constants/invoiceStatus";
import { useCallback } from "react";

type Args = {
  tenantId: string;
};

export const useUploadDocument = ({ tenantId }: Args) => {
  const uploadDocument = useCallback(
    ({
      acceptedFiles,
      invoiceType = InvoiceType.PAYABLE,
      onUploadError,
      onUploadSuccess,
    }: {
      acceptedFiles: any;
      invoiceType?: InvoiceType;
      onUploadError?: (error: any | Error) => void;
      onUploadSuccess?: (result: any) => void;
    }) =>
      uploadPdf({
        files: acceptedFiles,
        tenantId,
        onSuccess: onUploadSuccess,
        onError: onUploadError,
        invoiceType,
      }),
    [tenantId],
  );

  return { uploadDocument };
};
